import { createLucideIcon } from "lucide-react";

export const Link = createLucideIcon(
    "Link",
    [
        [
            "path",
            {
                d: "M14.6095 16.8462L12 19.4558C9.9411 21.5147 6.603 21.5147 4.5442 19.4558C2.4853 17.3969 2.4853 14.0588 4.5442 12L7.1537 9.3904",
                key: "stdflv",
            },
        ],
        [
            "path",
            {
                d: "M16.8463 14.6095L19.4558 12C21.5147 9.9411 21.5147 6.603 19.4558 4.5441C17.397 2.4852 14.0589 2.4852 12 4.5441L9.3905 7.1537",
                key: "188vk5",
            },
        ],
        [
            "path",
            {
                d: "M9.5 14.5L14.5 9.49995",
                key: "mp9et2",
            },
        ],
    ],
);
